import StockSearchItemBase from "@/classes/stock/StockSearchItemBase";

export default class StockSearchItem extends StockSearchItemBase{
    constructor() {

        super()

        this.zeroQty = false;

    }
}
